import { createEvent, restore } from "effector";

export interface ISiteColors {
    headerColor: string
    headerShadow: string
    headerTextColor: string
    headerDarkMenu: string
    footerColor: string
    footerLinkColor: string
    footerCopyrightColor: string
    ComId: number
    backTotal: string
    backBtnSubmit: string
    backBtnTotalByMonth: string
    backBtnPayDebt: string
    backRoutePanel: string
    backgroundColor:string
    sideBarText:string
    searchField:string
    searchFieldStyle:string
    cardBackgroundColor:string
    cardColor:string
    titleColor:string
    backBtnTotalByMonthText:string
    chargeTextColor:string
}


export const setSiteColors = createEvent<ISiteColors>();
export const $SiteColors = restore<ISiteColors>(setSiteColors, {} as ISiteColors);